module.exports = __webpack_public_path__ + "static/img/trial_plan_icon.9bbcea23.svg";